module.exports = __webpack_public_path__ + "img/logo_about_us.08923f15.png";